import { render, staticRenderFns } from "./immersion04.vue?vue&type=template&id=7ab09dc2&scoped=true&"
import script from "./immersion04.vue?vue&type=script&lang=js&"
export * from "./immersion04.vue?vue&type=script&lang=js&"
import style0 from "./immersion04.vue?vue&type=style&index=0&id=7ab09dc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ab09dc2",
  null
  
)

export default component.exports